import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-bc31230c"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "menu-title"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "tab-list"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "item-info"
};
const _hoisted_6 = {
  class: "item-name"
};

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "arrow"
}, null, -1));

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "arrow-mask"
}, null, -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["menu-item", {
      'menu-item-last': $props.isLast
    }])
  }, [_createElementVNode("div", _hoisted_1, [$props.menuData.icon ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    class: "icon",
    src: $props.menuData.icon,
    alt: ""
  }, null, 8, _hoisted_2)) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString($props.menuData.title), 1)]), _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.menuList, item => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["tab-item", {
        'tab-item-checked': $props.checkedId == item.id,
        'tab-item-unchecked': $props.checkedId != item.id
      }]),
      onClick: $event => $options.checkedChange(item)
    }, [_createElementVNode("div", _hoisted_5, [_createElementVNode("span", _hoisted_6, _toDisplayString(item.name), 1), _createElementVNode("span", null, "(" + _toDisplayString(item.count) + ")", 1)]), _hoisted_7, _hoisted_8], 10, _hoisted_4);
  }), 256))]), $options.showExpandBtn ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    onClick: _cache[0] || (_cache[0] = (...args) => $options.expand && $options.expand(...args)),
    class: "expand-btn"
  }, _toDisplayString($data.expandStatus === 0 ? '+' : '-'), 1)) : _createCommentVNode("", true)], 2);
}